import Fast2Render from './components/render/widget/fast2render.vue';
import ComponentRender from './components/render/componentRender.vue';
import ComponentItemRender from './components/render/componentItemRender.vue';
import TabRender from './components/render/tabRender';
import ButtonGroupRender from './components/render/widget/render-button-group';
import BlockProvider from './components/render/widget/block-provider';
import PageProvider from './components/render/widget/page-provider';
import ThemeProvider from './components/render/widget/theme-provider';
import RowProvider from './components/render/widget/row-provider'; // 单据行项目专用组件
import RowPageProvider from './components/render/widget/row-page-provider'; // 单据行项目专用组件
import RowVxeProvider from './components/render/widget/row-vxe-provider'; // vxe-table表格组件
import BusinessFormsProvider from './components/render/widget/business-forms-provider'; // 业务类型-表单专用组件
import BusinessTypesProvider from './components/render/widget/business-types-provider'; // 业务类型-下拉列表专用组件
import HeadProvider from './components/render/widget/head-provider'; // 业务类型单据头专用组件
import HeadPageProvider from './components/render/widget/head-page-provider'; // 模块单据头专用组件
import SearchProvider from './components/render/widget/search-provider'; // 业务类型单据头专用组件
import ConfigTabRender from './components/render/widget/render-config-tab';
import CostConfigTabRender from './components/render/widget/render-cost-config-tab';
import ConfigTabSetting from './components/render/widget/setting-config-tab';
import TemplateProvider from './components/render/widget/template-provider';
import PageHeader from './components/render/widget/page-header';
import PageListHeader from './components/render/widget/page-list-header';
import PageDetailHeader from './components/render/widget/page-detail-header';
import BusinessRuleConfig from './components/render/widget/render-rule-config';
import AttachmentList from './components/render/attachmentList';
import RfqAttachmentList from './components/render/rfqAttachmentList';
import auth from './lib/auth';
import SelectDialog from './components/render/selectDialog/selectDialog';
import SelectDialogTable from './components/render/selectDialog/selectDialogTable';
import SelectVxeDialog from './components/render/selectDialog/selectVxeDialog';
import Tree from './components/render/tree/index';
import Upload from './components/render/uploader';
import BaseSelect from './components/render/dialog/basic';
import SelectMaterial from './components/render/dialog/material';
import SelectPurchaseGroup from './components/render/dialog/purchaseGroup';
import SelectSupplier from './components/render/dialog/supplier';
import SelectFactory from './components/render/dialog/factory';
import SelectCompany from './components/render/dialog/company';
import SelectDepartment from './components/render/dialog/department';
import SelectOrder from './components/render/dialog/order';
import SelectVoucher from './components/render/dialog/voucher';
import SelectDelivery from './components/render/dialog/delivery';
import SelectRecon from './components/render/dialog/reconNumber';
import SelectCostCenter from './components/render/dialog/costCenter';
import SelectPriceRecord from './components/render/dialog/priceRecord';
import SelectEmployee from './components/render/dialog/employee';
import SelectPurchaseOrganization from './components/render/dialog/purchaseOrganization';
import SelectPurchaseLeader from './components/render/dialog/purchaseLeader';
import SelectSupplierBoxDialog from './components/render/dialog/selectSupplierBoxDialog';
import SelectSupplierAndSubBoxDialog from './components/render/dialog/selectSupplierAndSubBoxDialog';
import SelectMaterialBoxDialog from './components/render/dialog/selectMaterialBoxDialog';
import PageSteps from './components/render/widget/render-page-steps'; // 页面步骤条
import Uploader from 'vue-simple-uploader';
import LadderJsonDialog from './components/render/dialog/ladderJsonDialog';
import CostJsonDialog from './components/render/dialog/costJsonDialog';
import BtnUpload from './components/render/btnUpload';
import SuperQuery from './components/render/dialog/superQuery.vue'; // 高级查询

import { updateBizDic } from './components/render/core/utils';

import { getStore, setStore } from './lib/store';
import util, {
  loadDic,
  getDicItem,
  getTableItem,
  getTemplateItem,
  getFormulaValue,
  getFormulaItem,
  getFormulaList,
  getBlockItem,
  getBlockFieldItem,
  getTableList,
  getDicNow,
  getApiPath,
  getRowPermission,
  handlerLocalPermission,
  handlerLocalRolePermission,
  ft
} from './lib/utils';
import repeatClick from './lib/repeatClick';

export default {
  install(Vue) {
    Vue.use(repeatClick);
    Vue.use(Uploader);

    Vue.component('Fast2' + SuperQuery.name, SuperQuery);
    Vue.component('Fast2' + Fast2Render.name, Fast2Render);
    Vue.component('Fast2' + ComponentRender.name, ComponentRender);
    Vue.component('Fast2' + ComponentItemRender.name, ComponentItemRender);
    Vue.component('Fast2' + TabRender.name, TabRender);
    Vue.component(ButtonGroupRender.name, ButtonGroupRender);
    Vue.component('Fast2' + BlockProvider.name, BlockProvider);
    Vue.component('Fast2' + PageProvider.name, PageProvider);
    Vue.component('Fast2' + TemplateProvider.name, TemplateProvider);
    Vue.component('Fast2' + ThemeProvider.name, ThemeProvider);
    Vue.component('Fast2' + RowProvider.name, RowProvider);
    Vue.component('Fast2' + RowPageProvider.name, RowPageProvider);
    Vue.component('Fast2' + RowVxeProvider.name, RowVxeProvider);
    Vue.component('Fast2' + BaseSelect.name, BaseSelect);

    Vue.component('Fast2' + BusinessFormsProvider.name, BusinessFormsProvider);
    Vue.component('Fast2' + BusinessTypesProvider.name, BusinessTypesProvider);
    Vue.component('Fast2' + HeadProvider.name, HeadProvider);
    Vue.component('Fast2' + HeadPageProvider.name, HeadPageProvider);
    Vue.component('Fast2' + PageSteps.name, PageSteps);
    Vue.component('Fast2' + SearchProvider.name, SearchProvider);
    Vue.component('Fast2' + ConfigTabRender.name, ConfigTabRender);
    Vue.component('Fast2' + CostConfigTabRender.name, CostConfigTabRender);
    Vue.component('Fast2' + ConfigTabSetting.name, ConfigTabSetting);
    Vue.component(PageHeader.name, PageHeader);
    Vue.component(PageListHeader.name, PageListHeader);
    Vue.component(PageDetailHeader.name, PageDetailHeader);
    Vue.component('Fast2' + AttachmentList.name, AttachmentList);
    Vue.component('Fast2' + Upload.name, Upload);
    Vue.component('Fast2' + SelectMaterial.name, SelectMaterial);
    Vue.component('Fast2' + SelectPurchaseGroup.name, SelectPurchaseGroup);
    Vue.component('Fast2' + SelectSupplier.name, SelectSupplier);
    Vue.component('Fast2' + SelectFactory.name, SelectFactory);
    Vue.component('Fast2' + SelectCompany.name, SelectCompany);
    Vue.component('Fast2' + SelectDepartment.name, SelectDepartment);
    Vue.component('Fast2' + SelectOrder.name, SelectOrder);
    Vue.component('Fast2' + SelectVoucher.name, SelectVoucher);
    Vue.component('Fast2' + SelectDelivery.name, SelectDelivery);
    Vue.component('Fast2' + SelectRecon.name, SelectRecon);
    Vue.component('Fast2' + SelectEmployee.name, SelectEmployee);
    Vue.component('Fast2' + SelectPurchaseOrganization.name, SelectPurchaseOrganization);
    Vue.component('Fast2' + SelectPurchaseLeader.name, SelectPurchaseLeader);
    Vue.component('Fast2' + SelectSupplierBoxDialog.name, SelectSupplierBoxDialog);
    Vue.component('Fast2' + SelectSupplierAndSubBoxDialog.name, SelectSupplierAndSubBoxDialog);
    Vue.component('Fast2' + SelectMaterialBoxDialog.name, SelectMaterialBoxDialog);
    Vue.component('Fast2' + SelectCostCenter.name, SelectCostCenter);
    Vue.component('Fast2' + SelectPriceRecord.name, SelectPriceRecord);
    Vue.component('Fast2' + BtnUpload.name, BtnUpload);

    Vue.component('Fast2' + RfqAttachmentList.name, RfqAttachmentList);

    Vue.component('Fast2' + LadderJsonDialog.name, LadderJsonDialog);
    Vue.component('Fast2' + CostJsonDialog.name, CostJsonDialog);

    Vue.component(AttachmentList.name, AttachmentList);
    Vue.component(RfqAttachmentList.name, RfqAttachmentList);

    Vue.prototype.$loadDic = loadDic;
    Vue.prototype.$getDicItem = getDicItem;
    Vue.prototype.$getDicNow = getDicNow;
    Vue.prototype.$getTableItem = getTableItem;
    Vue.prototype.$getTableList = getTableList;
    Vue.prototype.$getTemplateItem = getTemplateItem;
    Vue.prototype.$getFormulaValue = getFormulaValue;
    Vue.prototype.$getFormulaItem = getFormulaItem;
    Vue.prototype.$getFormulaList = getFormulaList;
    Vue.prototype.$getBlockItem = getBlockItem;
    Vue.prototype.$getBlockFieldItem = getBlockFieldItem;
    Vue.prototype.$updateBizDic = updateBizDic;

    Vue.prototype.$util = util;
    Vue.prototype.$util.loadDic = loadDic;
    Vue.prototype.$util.getDicNow = getDicNow;
    Vue.prototype.$util.setStore = setStore;
    Vue.prototype.$util.getStore = getStore;
    Vue.prototype.$util.getApiPath = getApiPath;
    Vue.prototype.$util.getRowPermission = getRowPermission;
    Vue.prototype.$util.handlerLocalPermission = handlerLocalPermission;
    Vue.prototype.$util.handlerLocalRolePermission = handlerLocalRolePermission;
    Vue.prototype.$util.updateBizDic = updateBizDic;

    Vue.prototype.$auth = auth;
    Vue.prototype.$ft = ft; // 国际化自定义方法
    Vue.component(BaseSelect.name, BaseSelect);
    Vue.component(BusinessRuleConfig.name, BusinessRuleConfig);
    Vue.component(SelectDialog.name, SelectDialog);
    Vue.component(SelectDialogTable.name, SelectDialogTable);
    Vue.component(SelectVxeDialog.name, SelectVxeDialog);
    Vue.component(Tree.name, Tree);
  }
};
